import { Chip, ChipProps } from '@mui/material';

export interface PropertyTagProps extends Omit<ChipProps, 'label'> {
  label: NonNullable<ChipProps['label']>;
}

export const PropertyTag = ({ sx, ...rest }: PropertyTagProps) => {
  return (
    <Chip
      size="small"
      sx={{ backgroundColor: 'neutrals.platinum', fontWeight: 'medium', textTransform: 'none', ...sx }}
      {...rest}
    />
  );
};
